import { createFileRoute, redirect } from '@tanstack/react-router'

// Marketing channels now live in Settings (name + publishable keys only). Redirect any old links
// so the layout editor, reached from the main Marketing nav, stays the single place for feed order.
export const Route = createFileRoute('/_authenticated/_general/marketing/channels')({
	beforeLoad: () => {
		throw redirect({ to: '/settings/marketing-channels' })
	}
})
